import { Dialog, DialogActions } from "@studio";
import type { CustomerStatus, Me } from "../lib/types";
import { MachineView } from "./machines";
import { ReadOnlyMachineView } from "./surface";

/**
 * 머신 공통 상세 다이얼로그 (시안 06a1acb machine-detail.tsx). 목록에서 열고, 고객사 상세 위에서 열면 "고객사 상세로" 돌아간다.
 * 직원: 상태·작업·디바이스·설정·버전 (MachineView). 고객: 상태·디바이스 읽기 전용 (ReadOnlyMachineView).
 */
export function MachineDetailDialog({
  me,
  customerId,
  machineId,
  customerStatus,
  label,
  onClose,
  onOpenTask,
  onBack,
  backLabel,
}: {
  me: Me;
  customerId: string;
  machineId: string | null;
  customerStatus: CustomerStatus;
  label?: string;
  onClose: () => void;
  onOpenTask: (runId: string | null) => void;
  onBack?: () => void;
  /** 되돌아갈 곳 이름 (기본 "고객사 상세로", 실행 상세에서 열면 "← 실행 상세로"). */
  backLabel?: string;
}) {
  const staff = me.isStaff && me.permissions.includes("TASK_DETAIL");
  return (
    <Dialog
      open={!!machineId}
      onOpenChange={(v) => !v && onClose()}
      title={label ? `${label} · 머신 상세` : "머신 상세"}
      description=""
      size="detail"
      footer={<DialogActions secondary={{ label: onBack ? (backLabel ?? "고객사 상세로") : "닫기", onClick: onBack ?? onClose }} />}
    >
      {machineId &&
        (staff ? (
          <MachineView customerId={customerId} machineId={machineId} customerStatus={customerStatus} onOpenTask={onOpenTask} onDeleted={onClose} />
        ) : (
          <ReadOnlyMachineView customerId={customerId} machineId={machineId} />
        ))}
    </Dialog>
  );
}
